import React, { useState } from "react";
import TopupModal from "../../features/Topup";
function Topup() {
  const [selectedProduct, setSelectedProduct] = useState("");
  const [showTopupModal, setShowTopupModal] = useState(false);
  const toggleTopupModal = () => {
    setShowTopupModal((prev) => !prev);
  };
  return (
    <div className="p-1 lg:p-10 min-h-[90vh]">
      <h2 className="font-bold mb-4 text-2xl text-pretty text-black">Top Up</h2>
      <div className="max-w-sm lg:max-w-md ">
        <label htmlFor="" className="flex items-center gap-2 text-black">
          Select Account:
          <select
            name="productType"
            id="productType"
            onChange={(e) => setSelectedProduct(e.target.value)}
            className="select select-bordered w-full  bg-transparent"
          >
            <option value="Legacy Money Market Fund">
              Legacy Money Market Fund
            </option>
            <option value="Legacy Equity Fund">Legacy Equity Fund</option>
          </select>
        </label>

        <div className=" mt-4 flex justify-center">
          <button
            className="btn bg-purple-800 rounded-md px-10 text-white"
            onClick={toggleTopupModal}
          >
            Top Up
          </button>
        </div>
      </div>
      <div className="prose max-w-none mt-4 text-black">
        <p>
          To top you can either use our virtual account feature where you will
          get bla bla bla. Get Write up from the digital team.
        </p>
      </div>

      <TopupModal
        open={showTopupModal}
        handleClose={toggleTopupModal}
        product={selectedProduct}
      />
    </div>
  );
}

export default Topup;
